import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useEffect } from 'react';
import { getLanguageFromLocale } from '../services/langService.js';

const SiteContextObject = createContext({});
const useSiteContext = () => {
    return useContext(SiteContextObject);
};
const SiteProvider = ({ site: inputSite, locale: inputLocale, children, }) => {
    const [site, setSite] = useState(inputSite);
    const [locale, setLocale] = useState(inputLocale);
    useEffect(() => {
        setSite(inputSite);
    }, [inputSite]);
    useEffect(() => {
        setLocale(inputLocale);
    }, [inputLocale]);
    return (jsx(SiteContextObject.Provider, { value: {
            site,
            locale,
            language: getLanguageFromLocale(locale),
            setSite,
            setLocale,
        }, children: children }));
};

export { SiteProvider, useSiteContext };
//# sourceMappingURL=SiteProvider.js.map
